import { useEffect, useRef } from 'react';
import { isFunction } from 'lodash';

export default function useDocumentReady(callback) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    if (isFunction(callbackRef.current)) {
      if (document.readyState === 'complete') {
        callbackRef.current();
      } else {
        document.addEventListener('DOMContentLoaded', () => {
          callbackRef.current();
        });
      }
    }
  }, []);
}
